import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col-reverse md:flex-row items-stretch justify-start md:space-x-8" }
const _hoisted_2 = { class: "flex-1 bg-white py-8" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode("Balance")
const _hoisted_4 = ["textContent"]

import { toRefs } from 'vue';
import { AccountPresenter, WalletAccount } from '@/models';


export default /*#__PURE__*/_defineComponent({
  props: {
    account: null,
    presenter: null
  },
  setup(__props: any) {

const props = __props as {
  account: WalletAccount,
  presenter: AccountPresenter,
}



const { account } = toRefs(props);

return (_ctx: any,_cache: any) => {
  const _component_base_label = _resolveComponent("base-label")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_base_label, null, {
        default: _withCtx(() => [
          _hoisted_3
        ]),
        _: 1
      }),
      _createElementVNode("p", {
        class: "text-4xl tabular-nums font-semibold",
        textContent: _toDisplayString(_unref(account).lamports.formattedWithSymbol)
      }, null, 8, _hoisted_4)
    ])
  ]))
}
}

})